import PropTypes from 'prop-types'
import React from 'react'
import Col from '../col'
import FormGroup from '../formGroup'
import FormInput from '../formInput'
import FormLabel from '../formLabel'
import { translate } from '../../helpers/stringHelpers'
import Pagination from '../pagination'
import Row from '../row'

const PaginationContainer = ({
  paginationId,
  itemPerPageId,
  itemsPerPageOptions,
  hasPagination,
  listingsPerPage,
  pageNumber,
  listingCount,
  paginationText,
  paginationUrl,
  handlePagination,
  setItemsPerPagePreference
}) => (
  <Row>
    <Col xs={12} md={6} lg={3}>
      <FormGroup className='page-item-count'>
        <FormInput type='select' id={itemPerPageId} size='sm' onChange={setItemsPerPagePreference} value={listingsPerPage} className='page-item-count__input'>
          {itemsPerPageOptions.map(itemCount => (
            <option key={`itemsPerPage__option--${itemCount}`} value={itemCount}>{itemCount}</option>
          ))}
        </FormInput>
        <FormLabel for={itemPerPageId} className='page-item-count__label'>
          {translate('JspPublicCodes_JSP_LISTINGS_PAGE_SIZE')}
        </FormLabel>
      </FormGroup>
    </Col>
    {hasPagination
      ? (
          <Col xs={12} md={6} lg={9} className='text-right'>
            <Pagination
              activePage={pageNumber}
              className='timed-auction__pagination timed-auction__pagination--bottom'
              id={paginationId}
              itemsPerPage={listingsPerPage}
              itemsTotal={listingCount}
              onChange={handlePagination}
              showDirections
              text={paginationText}
              url={paginationUrl}
            />
          </Col>
        )
      : null}
  </Row>
)

PaginationContainer.propTypes = {
  paginationId: PropTypes.string,
  itemPerPageId: PropTypes.string,
  hasPagination: PropTypes.bool,
  listingsPerPage: PropTypes.number,
  itemsPerPageOptions: PropTypes.array,
  pageNumber: PropTypes.number,
  listingCount: PropTypes.number,
  paginationText: PropTypes.string,
  paginationUrl: PropTypes.string,
  handlePagination: PropTypes.func,
  setItemsPerPagePreference: PropTypes.func
}

const isEqual = (a, b) => (
  a.paginationId === b.paginationId &&
  a.listingCount === b.listingCount &&
  a.listingsPerPage === b.listingsPerPage &&
  a.pageNumber === b.pageNumber &&
  a.paginationText === b.paginationText &&
  a.paginationUrl === b.paginationUrl
)

export default React.memo(PaginationContainer, isEqual)
